"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NBSP = void 0;
const NBSP = exports.NBSP = '\u00A0';